import { Component, OnInit } from '@angular/core';
import { UnidadesMedidasCultivosService } from '../../_services/unidades-medidas-cultivos.service';
import { UnidadMedidaCultivo } from '../../_models/unidad-medida-cultivo';

@Component({
  selector: 'app-unidades-medida',
  templateUrl: './unidades-medida.component.html',
  styleUrls: ['./unidades-medida.component.css']
})
export class UnidadesMedidaComponent implements OnInit {
  carInformacionInicial = true;
  unidadMedidaCultivo: UnidadMedidaCultivo;
  seccion = 'LIS';
  unidadesMedidasCultivo: UnidadMedidaCultivo[] = [];

  constructor(private unidadesMedidasCultivosService: UnidadesMedidasCultivosService) { }

  ngOnInit() {
    this.cargarInformacionInicial();
    
  }

  cargarInformacionInicial() {
    this.carInformacionInicial = true;
    this.unidadesMedidasCultivosService.getAll().subscribe((value) => {
      this.unidadesMedidasCultivo = value;
      this.carInformacionInicial = false;
    });
  }

  cambioSeccion(data: any){
    switch (data.seccion) {
      case 'LIS':
        this.irAListado(data);
        break;
      case 'FORM':
        this.agregarEditarUnidaMedida(data);
        break;
      default:
        break;
    }
  }

  irAListado(data: any) {
    if (data.actualizar) {
      this.cargarInformacionInicial();
    }
    this.seccion = data.seccion;
  }

  agregarEditarUnidaMedida(data: any){
    if (data.data) {
      this.unidadMedidaCultivo = data.data;
    } else {
      this.unidadMedidaCultivo = null;
    }
    this.seccion = data.seccion;
  }

}
